import { defineMessages } from "react-intl";

const AFFILIATION_SECTION = "affiliation-section";

const affiliationSectionMessages = defineMessages({
  title: {
    id: `${AFFILIATION_SECTION}.title`,
    defaultMessage: "Affiliations"
  },
  details: {
    id: `${AFFILIATION_SECTION}.details`,
    defaultMessage:
      "Connect to EBSCO products through your affiliation’s subscription and sign in to your account while connected. <b>Need more information?</b> Read about access to our products on the <a>EBSCO support site</a>."
  }
});

export default affiliationSectionMessages;
